// GENERATED by @platform/contracts from specs/identity/main.tsp. Do not edit; run `pnpm generate`.
/* eslint-disable */
import { createCaller } from '../../client/runtime.js';
import { operations } from './schemas.js';
export function createIdentityClient(options) {
    const call = createCaller(options);
    return {
        /** Open and recent invitations into the caller's tenant. */
        Invitations_list: (input = {}) => call(operations.Invitations_list, input),
        /** Invite someone into the tenant. Creates the user with a temporary password and emails them. */
        Invitations_create: (input) => call(operations.Invitations_create, input),
        /** One invitation. */
        Invitations_get: (input) => call(operations.Invitations_get, input),
        /** Re-send the invitation email with a fresh temporary password. */
        Invitations_resend: (input) => call(operations.Invitations_resend, input),
        /** Revoke a pending invitation. */
        Invitations_revoke: (input) => call(operations.Invitations_revoke, input),
        /** Who is calling, and under which membership. */
        Self_get: (input = {}) => call(operations.Self_get, input),
        /**
         * Record that the caller accepted these documents (a new version, after sign-up). 409 when a
         * version is not the current one: show the documents again. Answers `GET /me` afterwards.
         */
        Self_consent: (input) => call(operations.Self_consent, input),
        /** Every tenant the caller belongs to. Cross-tenant by nature; each row is scoped to its own tenant. */
        Self_memberships: (input = {}) => call(operations.Self_memberships, input),
        /** Members of the caller's tenant. */
        Members_list: (input = {}) => call(operations.Members_list, input),
        /** Remove a member from the tenant. Their identity is untouched elsewhere. */
        Members_remove: (input) => call(operations.Members_remove, input),
        /** One member of the caller's tenant. */
        Members_get: (input) => call(operations.Members_get, input),
        /** Change a member's roles, office, agent code or grants. */
        Members_update: (input) => call(operations.Members_update, input),
    };
}
//# sourceMappingURL=client.js.map